import React from "react";
import "./publicPages/casualtechStyles.css";
import NavBar from "./publicPages/NavBar";
import Sections from "./publicPages/Sections";
import Footer from "./publicPages/Footer";
import HeroBanner from "./publicPages/HeroBanner";

export default function CasualTech() {
  return (
    <>
      <NavBar />
      <HeroBanner />
      <main>
        <Sections />
      </main>
      <Footer />
    </>
  );
}
